// extracted by mini-css-extract-plugin
export default {"container":"logOut_container__5j6i8","header":"logOut_header__rYPLx","body":"logOut_body__bW+XR","buttonsRow":"logOut_buttonsRow__W4eSw"};